import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { CommandResult } from '../../../common/helpers/CommandResult';

export const rejectOpenTransactions = async (personId: string | number, loanId: string | number): Promise<CommandResult> => {
    const result = await AxiosClientFactory
        .getInstance()
        .post(`api/applicants/${personId}/consumerloans/${loanId}/rejectOpenTransactions`);

    return new CommandResult(result);
};
